import {
  jb_in_text_teaser_css_default
} from "./chunk.GJIYZMD2.js";
import {
  e
} from "./chunk.3XLWIJBS.js";
import {
  reset_css_default
} from "./chunk.YAATWOBE.js";
import {
  Linkable,
  jbLinkClickedEventToJbTrackingEvent
} from "./chunk.TC6HXM2Y.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  Spaceable
} from "./chunk.JI7MO3NT.js";
import {
  A,
  b,
  i
} from "./chunk.BPIW577J.js";
import {
  n
} from "./chunk.XW2RSTES.js";
import {
  __decorateClass
} from "./chunk.LUIRGYUH.js";

// src/components/jb-in-text-teaser/jb-in-text-teaser.ts
var JbInTextTeaser = class extends Linkable(Spaceable(i)) {
  firstUpdated() {
    if (!this.link) {
      this.style.setProperty("display", "none");
    }
  }
  _getContentSpacingProperties() {
    return { grid: true, type: "text", colsMdUp: 8 };
  }
  _tracking(e2) {
    const jbTrackingEvent = jbLinkClickedEventToJbTrackingEvent(e2, {
      component_name: "in-text-teaser",
      interaction_text: this.buttonLabel
    });
    if (jbTrackingEvent) {
      this.dispatchEvent(jbTrackingEvent);
    }
  }
  render() {
    const imgData = this.image;
    return b`<header>
        <div>${this.kicker ? b`<p class="kicker">${this.kicker}</p>` : A}</div>
        <div>
          ${this.market ? b`<jb-icon iconName="material:language"></jb-icon
                  ><jb-market-display
                    .marketName=${this.market.marketName}
                    .marketShortName=${this.market.marketShortName}
                  ></jb-market-display>` : A}
        </div>
      </header>
      <section class=${e({ "no-image": !imgData })}>
        ${imgData ? b`<div class="image-wrap">
                <a
                  data-linkable
                  @jb-link:clicked=${this._tracking}
                >
                  <jb-picture
                    .imgData=${imgData}
                    aspect="aspect_3by2"
                    fit="cover"
                  ></jb-picture>
                </a>
              </div>` : A}
        <div class="text-wrap">
          <a
            data-linkable
            @jb-link:clicked=${this._tracking}
          >
            <jb-heading variant="heading-md">${this.headline}</jb-heading>
            ${this.text ? b`<p>${this.text}</p>` : A}
          </a>
          ${this.buttonLabel ? b`<jb-button-secondary
                  .link=${this.link}
                  @jb-link:clicked=${this._tracking}
                  >${this.buttonLabel}</jb-button-secondary
                >` : A}
        </div>
      </section>`;
  }
};
JbInTextTeaser.styles = [reset_css_default, jb_in_text_teaser_css_default];
__decorateClass([
  n()
], JbInTextTeaser.prototype, "buttonLabel", 2);
__decorateClass([
  n({ reflect: true })
], JbInTextTeaser.prototype, "headline", 2);
__decorateClass([
  n({ type: Object })
], JbInTextTeaser.prototype, "image", 2);
__decorateClass([
  n()
], JbInTextTeaser.prototype, "kicker", 2);
__decorateClass([
  n({ type: Object })
], JbInTextTeaser.prototype, "market", 2);
__decorateClass([
  n()
], JbInTextTeaser.prototype, "text", 2);
JbInTextTeaser = __decorateClass([
  customElement("jb-in-text-teaser")
], JbInTextTeaser);

export {
  JbInTextTeaser
};
